module.exports = __webpack_public_path__ + "img/commitment.4ce87bac.svg";